
import { Fragment, useMemo, useRef } from 'react';
import { FaultIndicator } from '../timeline/Timeline';
import usePopover from '../popover/usePopover';
import FaultOverlay from './FaultOverlay';
import { DefinedFaultTask } from '../../simulate/my-scenario/utils/scenario-types';
import { groupFaultsByOverlap } from './helperFunction';

const Event = ({ group }: { group: DefinedFaultTask[] }) => {
    const { showPopover } = usePopover();
    const elRef = useRef<HTMLDivElement>(null);

    const start = Math.min(...group.map(g => g.startTime));
    const end = Math.max(...group.map(g => g.endTime));

    const handleMouseEnter = () => {
        if (!elRef.current) return;
        const rect = elRef.current.getBoundingClientRect();
        showPopover(rect, (<FaultOverlay Events={group} />));
    };
    return (
        <FaultIndicator
            indicatorRef={elRef}
            count={group.length}
            faultStartTime={start}
            faultEndTime={end}
            faultDuration={end - start}
            onMouseEnter={handleMouseEnter}
        />
    )
}

const TimelineFaultEvents = ({ faults }: { faults: DefinedFaultTask[] }) => {
    const groupedFaults = useMemo(() => groupFaultsByOverlap(faults), [faults]);
    return (
        <Fragment>
            {groupedFaults.map((group, idx) => {
                const uniqueId = group.length === 1 ? group[0].faultId : `fault-${idx}`;
                return (
                    <Event key={uniqueId} group={group} />
                );
            })}
        </Fragment>
    )
}

export default TimelineFaultEvents